import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../../components/layout/Header';
import Footer from '../../../components/layout/Footer';
import './PhysicsPlay.css';

const PhysicsLayout = ({ kicker, title, lead, children }) => {
  useEffect(() => {
    document.documentElement.classList.add('qn-home-html');
    document.body.classList.add('qn-home-body');
    return () => {
      document.documentElement.classList.remove('qn-home-html');
      document.body.classList.remove('qn-home-body');
    };
  }, []);

  return (
    <div className="pp-lab">
      <Header />
      <main className="pp-main">
        <Link to="/virtuallabs/physics" className="pp-back">← Playground</Link>
        {kicker && <p className="pp-kicker">{kicker}</p>}
        <h1>{title}</h1>
        {lead && <p className="pp-lead">{lead}</p>}
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default PhysicsLayout;
